import React from 'react'
import { Form } from 'react-bootstrap'
import './InputTextarea.scss'

interface InputTextareaProps {
  value?: string
  onChange?: (value: string) => void
  disabled?: boolean
  title?: string
  hint?: string
  placeholder?: string
  error?: string
  rows?: number
  monospace?: boolean
}

export const InputTextarea: React.FC<InputTextareaProps> = ({
  value = '',
  onChange,
  disabled = false,
  title,
  hint,
  placeholder,
  error,
  rows = 4,
  monospace = false,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(e.target.value)
  }

  return (
    <div className={`mb-3 ${error ? 'pb-3' : ''}`}>
      {title && (
        <label className="form-label mb-2" htmlFor="inputId">
          {title}
        </label>
      )}
      <div className="position-relative">
        <Form.Control
          as="textarea"
          id="inputId"
          value={value}
          onChange={handleChange}
          disabled={disabled}
          placeholder={placeholder}
          rows={rows}
          className={monospace ? 'font-monospace' : ''}
          isInvalid={!!error}
        />
        {hint && <small className="form-text text-muted" dangerouslySetInnerHTML={{ __html: hint }}></small>}
        {error && <div className="invalid-feedback position-absolute top-100">{error}</div>}
      </div>
    </div>
  )
}
